<script>
    import { writable } from 'svelte/store';
    import { setContext } from 'svelte';
    import { Database, aql } from 'arangojs/web';

    // --- Interface with the database
    const db = new Database({
        url: 'http://35.187.27.74:8529/',
        databaseName: 'vast2021',
        auth: { username: 'vast_user', password: 'aTh3aifa' },
    });

    // --- Helpers
    const _pass = (v) => v;
    const _store = {
        update: (fun) => {},
    };

    async function _query(db, q, store, fun) {
        let values = [];
        try {
            const cursor = await db.query(q);
            values = await cursor.all();
        } catch (err) {
            console.error(err.message);
        }
        // Apply the callback function
        values = fun(values);
        // Write values to the store
        store.update(() => values);
        return values;
    }

    // --- API
    function query(q, store = _store, fun = _pass) {
        return _query(db, q, store, fun);
    }

    function retrieve(q, fun = _pass) {
        const store = writable([]);
        _query(db, q, store, fun);
        return store;
    }

    // --- Set the context so slots can use the database
    const key = {};
    setContext(key, {
        retrieve,
        query,
        aql,
        db,
    });
</script>

<slot {key} />
